import React from "react";

// components
import {StatusSelector} from "../../../../designSystem/components/StatusSelector";
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {Dialog} from "../../../../designSystem/components/Dialog";
import {StandardLayout} from "../../../../components/StandardLayout";
import {TotalDisplay} from "../../../../components/PaginationBar";

import {CaseTable} from "../CaseTable";
import {CaseModalContent} from "../CaseModalContent";
import {
  useCaseListView,
  useCaseManagementData,
  useCaseManagementMutations,
  useCaseManagementUIState,
  useExportCases,
} from "../../hooks";

export const CaseManagementFeature = ({userRole, userToken }) => {
  const {cases, organizations, loading, refreshCases} = useCaseManagementData({userToken});
  const {
    selectedCase,
    selectedOrganization,
    selectedStatus,
    assigningStatus,
    dialogContent,
    message,
    messageType,
    sortColumn,
    sortOrder,
    mode,
    setDialogContent,
    setMessage,
    setMessageType,
    setSelectedStatus,
    handleSort,
    handleOnClickReportButton,
    handleOnClickSurveyButton,
    handleCloseDialog,
    handleChangeStatus,
    handleChangeAssigningOrganization,
    handleOnClickBrowseCase,
    handleOnClickDeleteButton,
  } = useCaseManagementUIState();
  const {filteredCases, sortedCases} = useCaseListView({
    cases,
    selectedStatus,
    sortColumn,
    sortOrder,
  });
  const {
    handleAccept,
    handleReject,
    handleAssign,
    handleDelete,
    handleReport,
    handleAssigningStatus,
  } = useCaseManagementMutations({
    userToken,
    assigningStatus,
    refreshCases,
    setDialogContent,
    setMessage,
    setMessageType,
  });

  const { exportData } = useExportCases({ data: cases });

  if (loading)
    return <LoadingView />

  return (
    <React.Fragment>
      <StandardLayout
        headerTitle="案件管理"
        headerActionLabel="匯出資料"
        headerActionIcon="fa-file-export"
        headerActionOnClick={exportData}
        body={
          <div className="w-full flex flex-col gap-4">
            <StatusSelector
              selectedStatus={selectedStatus}
              onChangeSelectedStatus={(value) => setSelectedStatus(value)}
            />
            <TotalDisplay numberOfData={filteredCases.length} />
            {filteredCases?.length > 0
              ? <CaseTable
                cases={sortedCases}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                userRole={userRole}
                organizations={organizations}
                selectedStatus={selectedStatus}
                handleSort={handleSort}
                handleOnClickBrowseCase={handleOnClickBrowseCase}
                handleOnClickDeleteButton={handleOnClickDeleteButton}
              />
              : null
            }
          </div>
        }
      />
      <Dialog
        isOpen={dialogContent !== ''}
        onBackdropClick={handleCloseDialog}
      >
        {CaseModalContent({
          userToken,
          message,
          messageType,
          selectedCase,
          organizations,
          mode,
          selectedOrganization,
          assigningStatus,
          handleCloseDialog,
          handleReport,
          handleAccept,
          handleReject,
          handleAssign,
          handleDelete,
          handleChangeStatus,
          handleChangeAssigningOrganization,
          handleOnClickReportButton,
          handleOnClickSurveyButton,
          handleAssigningStatus,
        })[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  );
};
